import React from 'react';
import { Typography } from '@mui/material';

export const FilterHeader: React.FC = () => {
  return (
    <header className="px-6">
      <Typography variant="h3" component="h3">
        Filtri
      </Typography>
    </header>
  );
};
